<template>
  <el-table-column
    v-bind="$attrs"
  />
</template>

<script>

  export default {
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_colors.scss";
  span {
    font-weight: 500;
    font-size: 14px;
    color: $dark-gray;
  }

  .users-status {
    display: flex;
    flex-direction: column;
    p {
      margin: 0;
      font-weight: 600;
      font-size: 10px;
      letter-spacing: 0.07em;
      color: white;
    }
  }

</style>
